import { AnexoProposta } from '../../model';
import { URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../seguranca/auth.service';

export class AnexoPropostaFiltro {
  dispensaInexigibilidade; 
  pagina = 0;
  itensPorPagina = 10;
}

@Injectable()
export class AnexoPropostaService {

  url: string;

  constructor(private http: AuthHttp,
    public auth: AuthService, ) {
    this.url = `${environment.apiUrl}/anexos-proposta`;
  }

  pesquisar(filtro:AnexoPropostaFiltro): Promise<any> {
    const params = new URLSearchParams();

    params.set('page', filtro.pagina.toString());
    params.set('size', filtro.itensPorPagina.toString());

    if (filtro.dispensaInexigibilidade) {
      params.set('dispensaInexigibilidade', filtro.dispensaInexigibilidade);
    }
   

    return this.http.get(`${this.url}`, { search: params })
      .toPromise()
      .then(response => {
        return response.json();
      })
  }

  listarTodos(): Promise<any> {
    return this.http.get(this.url)
      .toPromise()
      .then(response => response.json().content);
  }

  excluir(codigo: number): Promise<void> {
    return this.http.delete(`${this.url}/${codigo}`)
      .toPromise()
      .then(() => null);
  }

  adicionar(entidade:AnexoProposta): Promise<AnexoProposta> {
    return this.http.post(this.url, JSON.stringify(entidade))
      .toPromise()
      .then(response => response.json());
  }

  atualizar(entidade: AnexoProposta): Promise<AnexoProposta> {

    return this.http.put(`${this.url}/${entidade.id}`,
      JSON.stringify(entidade))
      .toPromise()
      .then(response => response.json() as AnexoProposta);
  }

  buscarPorCodigo(codigo: number): Promise<AnexoProposta> {
    return this.http.get(`${this.url}/${codigo}`)
      .toPromise()
      .then(response => {
        const entidade = response.json() as AnexoProposta;
        return entidade;
      });
  }

}
